import React, { ReactNode } from 'react';
import { JsxElement } from 'typescript';
import './BreadCrumb.scss';

interface BreadCrumbProps {
  domainPrefix: string;
  children?: ReactNode;
  rightItem?: ReactNode;
}

export default class BreadCrumb extends React.Component<BreadCrumbProps> {
  render() {
    return (
      <React.Fragment>
        <div id="navBreadCrumb">
          <a href={this.props.domainPrefix}>Home</a>
          {this.props.children}
          <div id="rightItem">{this.props.rightItem}</div>
        </div>
      </React.Fragment>
    );
  }
}
